// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"b5d7ab82","787":"c91c13eb"}[chunkId] + ".chunk.js";
};